module.exports = __webpack_public_path__ + "img/CCF6FA_9DD9EB_82C5D9_ACD4E4-256px.fb25adaf.png";